// Tam Ayar Landing Page Mock Data

export const companyInfo = {
  name: "Tam Ayar",
  slogan: "Kuyumcunun Dijital Mihenk Taşı",
  tagline: "İşinize Tam Ayar Verin",
  phone: "+90 534 225 89 84",
  email: "info@tamayar.com",
  company: "YS Teknoloji A.Ş.",
  whatsappLink: "https://wa.me/905342258984"
};

export const features = [
  {
    id: 1,
    title: "Hibrit Stok Yönetimi",
    subtitle: "Gramajlı ve Adetli Ürün",
    description: "Bilezik, hurda gibi gramajlı ürünleri ve pırlanta, saat gibi adetli ürünleri tek sistemde yönetin.",
    icon: "Layers"
  },
  {
    id: 3,
    title: "Çoklu Emtia Cüzdanı",
    subtitle: "Has, Dolar, Euro Cari Takibi",
    description: "Müşteri ve toptancı carilerini TL, has altın, çeyrek, 22 ayar veya döviz cinsinden ayrı ayrı takip edin.",
    icon: "Wallet"
  },
  {
    id: 4,
    title: "Tablet Vitrin Modu",
    subtitle: "Tezgahta Dijital Katalog",
    description: "Stokta olmayan modelleri bile müşteriye tablet üzerinden gösterin. Atölyeden sipariş alın.",
    icon: "Tablet"
  },
  {
    id: 5,
    title: "Akıllı CRM Sistemi",
    subtitle: "Özel Gün Takibi",
    description: "Evlilik yıl dönümü, doğum günü gibi özel günlerde satış fırsatı bildirimi alın.",
    icon: "Heart"
  },
  {
    id: 6,
    title: "WhatsApp Entegrasyonu",
    subtitle: "Tek Tıkla İletişim",
    description: "Satış sonrası fatura ve sertifikayı tek tıkla müşterinin WhatsApp'ına gönderin.",
    icon: "MessageCircle"
  }
];

export const comparisonData = {
  headers: ["Özellik", "Eski Sistemler", "Tam Ayar"],
  rows: [
    {
      feature: "Platform Desteği",
      old: "Sadece iPad'de çalışır",
      new: "Her cihazda çalışır (Web, Tablet, Mobil)"
    },
    {
      feature: "Fiyatlandırma",
      old: "Statik fiyat, manuel güncelleme",
      new: "Canlı borsa entegrasyonu, otomatik güncelleme"
    },
    {
      feature: "Müşteri Yönetimi",
      old: "Sadece satış kaydı",
      new: "Akıllı CRM ve satış tahmini"
    },
    {
      feature: "Cari Takibi",
      old: "Sadece TL bazlı",
      new: "Çoklu emtia cüzdanı (Has, Döviz, TL)"
    },
    {
      feature: "Raporlama",
      old: "Temel raporlar",
      new: "Detaylı analitik ve kar/zarar takibi"
    },
    {
      feature: "Güvenlik",
      old: "Yerel depolama",
      new: "%100 bulut güvenliği ve yedekleme"
    }
  ]
};

export const statistics = [
  {
    id: 1,
    value: "10.000+",
    label: "Günlük İşlem Hacmi",
    icon: "Activity"
  },
  {
    id: 2,
    value: "0",
    label: "Veri Kaybı",
    icon: "Shield"
  },
  {
    id: 3,
    value: "%100",
    label: "Bulut Güvenliği",
    icon: "Cloud"
  },
  {
    id: 4,
    value: "7/24",
    label: "Teknik Destek",
    icon: "Headphones"
  }
];

export const faqData = [
  {
    id: 1,
    question: "İnternetim kesilirse ne olur?",
    answer: "Tam Ayar, çevrimdışı modda da çalışmaya devam eder. İnternet bağlantınız geri geldiğinde tüm verileriniz otomatik olarak senkronize edilir. Satış, stok ve müşteri işlemleriniz kesintisiz devam eder."
  },
  {
    id: 2,
    question: "Verilerim güvende mi?",
    answer: "Evet, %100 güvende. Verileriniz 256-bit SSL şifreleme ile korunur ve günlük otomatik yedekleme yapılır. Bankacılık seviyesinde güvenlik protokolleri kullanıyoruz. Verilerinize sadece siz erişebilirsiniz."
  },
  {
    id: 3,
    question: "Eski programımdan geçiş yapabilir miyim?",
    answer: "Kesinlikle! Uzman ekibimiz eski sisteminizden tüm verilerinizi (stok, müşteri, cari) güvenli bir şekilde Tam Ayar'a aktarır. Geçiş süreci ortalama 1-2 gün sürer ve bu süreçte işleriniz aksamaz."
  },
  {
    id: 4,
    question: "Kaç kullanıcı aynı anda sistemi kullanabilir?",
    answer: "Sınırsız kullanıcı desteği sunuyoruz. Tezgah, kasa, depo ve yönetim ekibinizin hepsi aynı anda sisteme erişebilir. Her kullanıcıya farklı yetki seviyeleri tanımlayabilirsiniz."
  },
  {
    id: 5,
    question: "Eğitim ve destek sunuyor musunuz?",
    answer: "Evet! İlk kurulumda kapsamlı eğitim veriyoruz. Ayrıca 7/24 WhatsApp ve telefon desteği, video eğitimler ve kullanıcı kılavuzu ile her zaman yanınızdayız."
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Profesyonel",
    subtitle: "Tek Mağaza İşletmeleri İçin",
    price: "1.000",
    currency: "$",
    period: "/ yıl",
    features: [
      "Sınırsız ürün girişi",
      "Canlı borsa entegrasyonu",
      "Hibrit stok yönetimi",
      "Temel CRM özellikleri",
      "WhatsApp entegrasyonu",
      "Tablet vitrin modu",
      "E-posta desteği",
      "Günlük yedekleme"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Kurumsal",
    subtitle: "Çoklu Şube ve Toptancılar İçin",
    price: "1.500",
    currency: "$",
    period: "/ yıl",
    features: [
      "Profesyonel paketindeki her şey",
      "Çoklu şube yönetimi",
      "Gelişmiş cari takibi",
      "Çoklu emtia cüzdanı",
      "Detaylı raporlama ve analitik",
      "API erişimi",
      "Öncelikli 7/24 destek",
      "Özel eğitim ve kurulum"
    ],
    popular: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mehmet Yılmaz",
    title: "Yılmaz Kuyumculuk",
    location: "İstanbul, Kapalıçarşı",
    quote: "20 yıldır bu sektördeyim, ilk defa fiyat güncellemesiyle uğraşmıyorum. Tam Ayar hayatımı değiştirdi.",
    rating: 5
  },
  {
    id: 2,
    name: "Ayşe Demir",
    title: "Demir Gold",
    location: "Ankara",
    quote: "Müşterilerimin özel günlerini hatırlıyor olmak satışlarımı %30 artırdı. CRM sistemi muhteşem.",
    rating: 5
  },
  {
    id: 3,
    name: "Ali Kaya",
    title: "Kaya Toptancılık",
    location: "İzmir",
    quote: "3 şubemizi tek panelden yönetiyoruz. Has altın cari takibi sayesinde kur riski sıfır.",
    rating: 5
  }
];
